import { RootState } from 'reducers/store'

export const selectCurrentSubscriptionError = (state: Pick<RootState, 'error'>) => {
  return state.error.subscriptionError.value
}
